import {gql} from "@apollo/client/core";
import {PaymentMethodFragment} from "../fragments/payment-method-fragment";

export const GetOrderPaymentMethods = gql`
    query GetOrderPaymentMethods($orderId: Int) {
        getPlacedOrder(orderId: $orderId) {
            orderId
            paymentMethodsResponse {
                paymentMethods {
                    ...PaymentMethodFragment
                }
                productCredits {
                    ...PaymentMethodFragment
                }
            }
        }
    }
    ${PaymentMethodFragment}
`;

export const GetOrderRepaymentQuote = gql`
    query GetOrderRepaymentQuote($orderId: Int!) {
        getOrderRepaymentQuote(orderId: $orderId) {
            status
            orderTotal
            settledAmount
            remainingBalance
            retainedPaymentIds
            livePaymentIds
            blockingPaymentId
        }
    }
`;

export const ReplaceOrderPayment = gql`
    mutation ReplaceOrderPayment($input: ReplaceOrderPaymentInput!) {
        replaceOrderPayment(input: $input) {
            success
            failedStep
            message
            orderPayment {
                id
                paymentMethodType
                status
                paymentAmount
                currency
                message
            }
        }
    }
`;
